<template>
  <div>
    <a-card style="margin: 10px 0px">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchData"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>
    <a-card style="margin: 10px 0px">
      <div class="right">
        <a-button type="primary" icon="download" @click="exportFile">
          下载
        </a-button>
      </div>
      <TableView
        bordered
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        @handlePagination="handleClickPage"
        :data="tableData"
        :scroll="SCROLL"
      >
        <!--书面担保金额 writtenAmount -->
        <template v-slot:writtenAmount="{ tableRow }">
          <span>{{ tableRow.writtenAmount | formatAmount }}</span>
        </template>
        <!--担保金额(元) slot-->
        <template v-slot:validAmount="{ tableRow }">
          <span>{{ tableRow.validAmount | formatAmount }}</span>
        </template>
        <template v-slot:action="{ tableRow }">
          <a href="javascript:void(0)">
            <a-popover title="点击下载" trigger="hover">
              <template slot="content">
                <div v-if="tableRow.attachments.length">
                  <p v-for="item in tableRow.attachments" :key="item.id">
                    <a herf="javascript:;" @click="handleView(item.id)">
                      {{ tableRow.attachments.length && item.fileName }}
                    </a>
                  </p>
                </div>
                <a-empty v-else />
              </template>
              <span href="javascript:;" size="small" type="link">
                下载
              </span>
            </a-popover>
          </a>
          <a
            href="javascript:void(0)"
            @click="goDeatil(tableRow)"
            style="margin-left:10px;"
          >
            查看
          </a>
        </template>
      </TableView>
    </a-card>
  </div>
</template>

<script>
import { addAssurance, downUpload, download } from './api'
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import { formatParamDate } from 'utils/util'
import mixin from './mixin'
export default {
  data() {
    //这里存放数据
    const searchData = {
      applyEnddate: '',
      applyIndate: '',
      approveEnddate: '',
      approveIndate: '',
      bookType: '',
      bpmId: '',
      companyCode: '',
      companyName: '',
      status: '',
      username: '',
    }
    const searchForm = cloneDeep(searchData)
    return {
      tableLoading: true,
      SCROLL: { x: 2600 },
      searchForm,
      searchData,
      tableData: [],
    }
  },
  mixins: [mixin],
  components: { SearchView, TableView },

  //方法集合
  methods: {
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData(this.searchForm)
    },
    // 查询
    handleSearch(data) {
      data = formatParamDate(
        data,
        data.applyRangeDate,
        'applyIndate',
        'applyEnddate',
      )
      data = formatParamDate(
        data,
        data.approveRangeDate,
        'approveIndate',
        'approveEnddate',
      )
      delete data.applyRangeDate
      delete data.approveRangeDate
      this.searchForm = data
      this.pageData.current = 1
      this._getTableData(data)
    },
    // 下载
    exportFile() {
      download(this.searchForm)
    },
    //查看审批页
    goDeatil(data) {
      this.$router.push({
        path: `/Item/guarantee-detail/guarantee-approval/${data.bpmId}`,
        query: {
          companyCode: data.companyCode,
          typeStr: 2,
        },
      })
    },
    // 下载附件
    async handleView(id) {
      await downUpload(id)
    }, // 获取表格数据
    async _getTableData(searchForm) {
      this.tableLoading = true
      try {
        const { current, pageSize } = this.pageData
        const query = {
          ...searchForm,
          size: pageSize,
          current,
        }
        const {
          data: { total, records },
        } = await addAssurance(query)
        this.pageData.total = total
        this.tableData = records
        this.tableData.map(item => {
          item.expireDate = moment(item.expireDate).format('YYYY-MM-DD')
          item.efficientDate = moment(item.efficientDate).format('YYYY-MM-DD')
        })
        this.tableLoading = false
      } catch (error) {
        console.log(error)
      }
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getTableData(this.searchForm)
  },
}
</script>
<style scoped lang="less">
.right {
  text-align: right;
  margin-bottom: 20px;
}
/* @import url(); 引入css类 */
</style>
